import * as React from "react";
import { SVGProps } from "../types";

const SwiftIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#172A73"
      d="M2 16C2 8.268 8.268 2 16 2s14 6.268 14 14-6.268 14-14 14S2 23.732 2 16"
    ></path>
    <path
      fill="#fff"
      d="M5.574 9.745v.595l2.178.343a3.855 3.855 0 0 1 3.147 2.935l2.55 10.86a.59.59 0 0 0 .575.458H17.6c.236 0 .45-.141.543-.36l6.172-14.415a.298.298 0 0 0-.272-.416h-3.296a.59.59 0 0 0-.545.365l-4.134 9.911-1.65-8.82a1.78 1.78 0 0 0-1.743-1.456z"
    ></path>
  </svg>
);

export { SwiftIcon };
